import React, { useEffect, useRef, useState } from 'react';
import Lazyimg from '@components/utils/Lazyimg';
import classNames from 'classnames';
const CubeGallerySlide = (props) => {
    const { slide } = props;
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const descriptionRef = useRef(null);
    const shadowRef = useRef(null);
    const [height, setHeight] = useState(0);
    useEffect(() => {
        if (!descriptionRef.current || !slide.data.paragraph) {
            return;
        }
        setHeight(descriptionRef.current.scrollHeight);
        window.addEventListener('resize', function () {
            setHeight(descriptionRef.current.scrollHeight);
        });
    }, [descriptionRef, slide]);
    useEffect(() => {
        if (descriptionRef.current && shadowRef.current) {
            if (open) {
                descriptionRef.current.style.height = descriptionRef.current.scrollHeight + 'px';
                shadowRef.current.style.height = `calc(50% + ${descriptionRef.current.scrollHeight}px)`;
                shadowRef.current.style.opacity = '0.8';
            }
            else {
                descriptionRef.current.style.height = '0px';
                shadowRef.current.style.opacity = '0';
            }
        }
    }, [open, height]);
    useEffect(() => {
        setOpen(false);
    }, [props.slideIndex]);
    if (!slide) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { role: "button", className: "cube-gallery-slide slide", ref: ref, onMouseUp: () => {
            props.enableClick && slide.data.paragraph && setOpen(!open);
        }, tabIndex: 0, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                slide.data.paragraph && setOpen(!open);
            }
        } },
        React.createElement("picture", null,
            React.createElement("source", { media: "(max-width: 768px)", srcSet: slide.custom['mobileImage'].src }),
            React.createElement(Lazyimg, { className: "cube-gallery-slide__image", src: slide.custom['desktopImage'].src, alt: slide.data.imgAlt || '' })),
        (slide.data.paragraph || slide.data.title) && React.createElement("div", { className: "blurred-shadow" }),
        slide.data.paragraph && React.createElement("div", { className: "blurred-shadow-opened", ref: shadowRef }),
        (slide.data.paragraph || slide.data.title) && (React.createElement("div", { className: "cube-gallery-slide__accordion" },
            React.createElement("div", { className: "text-wrapper" },
                React.createElement("h2", { className: "cube-gallery-slide__title" }, slide.data.title),
                React.createElement("div", { className: classNames('cube-gallery-slide__description', { closed: !open }), ref: descriptionRef },
                    React.createElement("p", null, slide.data.paragraph))),
            slide.data.paragraph && (React.createElement("div", { className: "button-wrapper" },
                React.createElement("button", { className: `${open ? 'minus' : 'plus'}-icon`, onClick: (e) => {
                        e.preventDefault();
                    } })))))));
};
export default CubeGallerySlide;
